import CityPageTemplate from "../city-template/CityPageTemplate";
import { sewardConfig } from "./data";

export default function SewardPage() {
  return <CityPageTemplate config={sewardConfig} />;
}